import produce from 'immer';
import { set } from 'lodash';
import CONST from '../_actions';

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CONST.SET_DATA:
      return produce(state, draftState => {
        set(draftState, payload.path, payload.data);
      });

    default:
      return state;
  }
};
